import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';


/**
 * Interfaz para el documento del propietario
 */
export interface OwnerDocument {
  type: string;
  number: string;
}

/**
 * Interfaz para la información del propietario
 */
export interface Owner {
  fullname: string;
  document: OwnerDocument;
}

/**
 * Componente PlanCardComponent
 * Muestra la información del plan seleccionado, vehículo y coberturas
 * @component
 */
@Component({
  selector: 'app-summary-plan-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './summary-plan-card.component.html',
  styleUrl: './summary-plan-card.component.scss',
})
export class SummaryPlanCardComponent {
  // --- Entradas del componente convertidas a signals ---
  planTitle = input<string>('');
  vehicleBrand = input<string>('');
  vehicleLine = input<string>('');
  owner = input<Owner | null>(null);
  city = input<string>('');
  /** Coberturas incluidas, ya traducidas al texto del resumen y ordenadas. */
  coverageLabels = input<string[]>([]);
  /** Coberturas opcionales que el usuario activo, ya traducidas. */
  optionalCoverageLabels = input<string[]>([]);
  isCustomPlan = input<boolean>(false);
  paymentType = input(''); // 'Anual' o 'Mensual'
  totalAmount = input(0);
  monthlyAmount = input(0);
  showDiscount = input(false);

  isExpanded = signal(true);

  /**
   * Obtiene el tipo de documento formateado
   */
  getDocumentType(type: string): string {
    const types: Record<string, string> = {
      C: 'C.C.',
      E: 'C.E.',
      P: 'P.',
    };
    return types[type] || type;
  }

  subtotalCalculated = computed(() => {
    if (this.paymentType() === 'Mensual') {
      return this.totalAmount() * 12;
    }
    return Math.ceil(this.totalAmount() / 0.8);
  });

  annualSaving = computed(() => {
    return this.subtotalCalculated() - this.totalAmount();
  });

  discountAmount = computed(() => {
    return this.showDiscount() ? this.totalAmount() * 0.2 : 0;
  });

  paymentFrequency = computed(() => {
    return this.paymentType() === 'Anual' ? '/año' : '';
  });

  formatPrice(value: number): string {
    const formatted = new Intl.NumberFormat('es-CO').format(value);
    return value >= 1000000 ? formatted.replace('.', '´') : formatted;
  }

  toggleExpanded(): void {
    this.isExpanded.update(value => !value);
  }
}
